import React from 'react';

const SVG = ({
  style = {},
  fill = '#000',
  viewBox = '0 0 16 16',
  width = '100%',
  className = '',
  height = '100%',
  ...rest
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox={viewBox}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...rest}
  >
    <g fill={fill}>
      <g>
        <path d="M6,1V6H1V9H6v5H9V9h5V6H9V1Z" />
      </g>
    </g>
  </svg>
);
export default SVG;
